import { render, staticRenderFns } from "./costHelpSixtyTage.vue?vue&type=template&id=a210e600&"
import script from "./costHelpSixtyTage.vue?vue&type=script&lang=js&"
export * from "./costHelpSixtyTage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a210e600')) {
      api.createRecord('a210e600', component.options)
    } else {
      api.reload('a210e600', component.options)
    }
    module.hot.accept("./costHelpSixtyTage.vue?vue&type=template&id=a210e600&", function () {
      api.rerender('a210e600', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2u1eON4XuzoIb/JS/costHelpSixtyTage.vue"
export default component.exports